import React from 'react';

const ButtonWalletTransaction = ({ Icon, label, onClick }) => {
  return (
    <button
      onClick={onClick}
      className="group flex flex-col w-full justify-center items-center h-full gap-2 rounded-xl cursor-pointer transition-transform duration-700 hover:scale-[0.95] focus:outline-none focus:ring-2 focus:ring-[#5E5E63] bg-[#1a1b22] hover:bg-[#1a1b22]"
    >
      {Icon && <Icon className="h-6 w-6  group-hover:text-black  " alt="cripto wallet" />}
      <p className="text-base text-white group-hover:text-white">{label}</p>
    </button>
  );
};

export default ButtonWalletTransaction;
